<template>
  <p class="tag">
    <slot/>
  </p>
</template>

<script setup lang="ts">

</script>

<style lang="scss">
.tag {
  padding: 8px 16px;

  color: #FFF;
  text-align: center;
  font-family: var(--font-family-main);
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;

  background-color: #E43233;
  border-radius: 8px;
}
</style>